import {
  Button,
  Form,
  FormItem,
  Input,
  Modal,
  SubmitButton,
} from '../../../../../components';
import {
  validateChunkValue,
  validateDomains,
} from '../../../../../components/AgentForm/utils/validators';

export const DEFAULT_CHUNK_SIZE = 2500;
export const DEFAULT_CHUNK_OVERLAP = 250;
const MIN_CHUNK_VALUE = 0;

export type ExtendByUrlForm = {
  url: string;
  chunk_size: number;
  chunk_overlap: number;
};

type ExtendByUrlModalProps = {
  open: boolean;
  onClose: () => void;
  formKey: string;
  urlForm: ExtendByUrlForm;
  onFormChange: (values: ExtendByUrlForm) => void;
  onExtend: () => void;
  extending: boolean;
};

export const ExtendByUrlModal = ({
  open,
  onClose,
  formKey,
  urlForm,
  onFormChange,
  onExtend,
  extending,
}: ExtendByUrlModalProps) => {
  return (
    <Modal
      size="small"
      open={open}
      onClose={onClose}
      title="Add content by URL"
    >
      <div className="flex flex-col gap-y-12 w-full">
        <Form onChange={onFormChange} initialValue={urlForm} key={formKey}>
          <FormItem<ExtendByUrlForm>
            name="url"
            label="URL"
            inline={false}
            required
            validate={validateDomains(['http', 'https'])}
          >
            <Input placeholder="https://example.com" />
          </FormItem>
          <FormItem<ExtendByUrlForm>
            name="chunk_size"
            label="Chunk size"
            inline={false}
            required
            validate={validateChunkValue({
              min: MIN_CHUNK_VALUE,
              otherFieldName: 'chunk_overlap',
              errorMessage: 'Chunk size cannot be less than chunk overlap',
              comparison: 'lessThan',
            })}
          >
            <Input numeric />
          </FormItem>
          <FormItem<ExtendByUrlForm>
            name="chunk_overlap"
            label="Chunk overlap"
            inline={false}
            required
            validate={validateChunkValue({
              min: MIN_CHUNK_VALUE,
              otherFieldName: 'chunk_size',
              errorMessage: 'Chunk overlap cannot be greater than chunk size',
              comparison: 'greaterThan',
            })}
          >
            <Input numeric />
          </FormItem>
          <div className="flex flex-col gap-y-md justify-center items-center">
            <SubmitButton
              size="medium"
              disabled={extending}
              className="w-full"
              label="Extend"
              onClick={onExtend}
            />
            <Button
              size="medium"
              type="contrast"
              label="Cancel"
              className="w-full text-main"
              onClick={onClose}
            />
          </div>
        </Form>
      </div>
    </Modal>
  );
};
